exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".row__2xn {\n  display: flex;\n  align-items: center;\n  margin: 0 -10px; }\n  .row__2xn > div {\n    margin: 0 10px; }\n", ""]);
// Exports
exports.locals = {
	"row": "row__2xn"
};